/* eslint-disable react/jsx-no-useless-fragment */
import { Drawer, Primary, SvgIcon, Text } from '@cinch-labs/design-system'
import { useMaintenanceContext } from '../../../context/maintenance-context'
import { useManufacturerApprovedDrawer } from './manufacturer-approved-drawer.context'
import {
  useAnalytics,
  TrackingEventTypes,
  EventNames,
} from '@cinch-nx/shared-analytics'
import styles from './manufacturer-approved-drawer.module.css'

export const ManufacturerApprovedDrawer = () => {
  const { trackEvent } = useAnalytics()
  const {
    setShowManufacturerApprovedDrawer,
    showManufacturerApprovedDrawer,
    nearestOemStoreName,
    nearestOemStoreDistance,
  } = useManufacturerApprovedDrawer()
  const { vehicleMake } = useMaintenanceContext()

  const handleClick = () => {
    setShowManufacturerApprovedDrawer(!showManufacturerApprovedDrawer)
  }

  const handleBookService = () => {
    trackEvent({
      eventName: `Toggle Store Map`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'cinch_servicing',
          action: 'confirm_and_leave_OEM_options',
          label: 'make_a_booking_OEM_options',
          type: nearestOemStoreName,
          value: nearestOemStoreDistance,
        },
      },
    })
    const make = vehicleMake?.toLowerCase() ?? ''
    window.open(
      `https://www.marshall.co.uk/${make}/service/service-booking?utm_source=cinch&utm_medium=referral&utm_campaign=cinch-servicing-oem`,
      '_blank',
      'noopener,noreferrer',
    )
  }

  return (
    <>
      {showManufacturerApprovedDrawer && (
        <Drawer
          onClose={() => handleClick()}
          header={'Manufacturer-approved servicing'}
          ariaLabelledById="manufacturer-approved-servicing-drawer"
        >
          <Text fontSizeFixed="s">
            If your car’s still under warranty, a manufacturer service can help
            make sure it’s protected.
          </Text>
          <br></br>
          <br></br>
          <Text fontSizeFixed="s">
            Give your car the treatment it deserves with manufacturer-trained
            technicians and genuine parts that won’t affect your warranty.
          </Text>
          <br></br>
          <br></br>
          <Text fontSizeFixed="s">
            You can book a manufacturer service with our partners, Marshall
            Motor Group, at a service centre near you. Servicing prices may be
            different to what you’ve seen on cinch’s website.
          </Text>
          <br></br>
          <br></br>
          <Text className={styles.finalText} fontSizeFixed="s">
            Visit the Marshall website to find your nearest location and get
            booked in.
          </Text>
          <Primary onClick={handleBookService}>
            <SvgIcon
              name="external-link"
              size={14}
              className={styles.externalLinkIcon}
            />
            Book manufacturer service
          </Primary>
        </Drawer>
      )}
    </>
  )
}

export default ManufacturerApprovedDrawer
